import {Backbone, _} from 'backboneAdapter';
import Handlebars from 'handlebars';
import Template from 'js/templates/service.row.hbs';
import {serviceBalloonClass, ServiceTypes} from 'js/serviceutil';

require('interfaceAdapter');


const ResultView = Backbone.View.extend({
    tagName: 'div',
    className: 'balloonvoucher top bg-hover-grayLight',
    template: Handlebars.compile(Template),
    ServiceTypes: ServiceTypes,
    initialize: function (options) {
        this.options = options;
        this.model.bind('change', this.render, this);
        this.model.bind('destroy', this.remove, this);
    },
    render: function () {
        const campaignTemplateType = this.model.get("campaignTemplateType");
        let serviceType = this.ServiceTypes[campaignTemplateType];
        if (serviceType === "payPalPayment") {
            var payPalButtons = _.filter(this.model.get("surveyPageConfig").get("components").models, function (component) {
                return component.get("type") === "PayPalButton";
            });
            if (payPalButtons && payPalButtons.length) {
                this.model.set("amount", payPalButtons[0].get("price"));
            }
        }
        var templateParams = this.model.toJSON();
        // templateParams.usedFor = this.options.usedFor;
        // templateParams.triggeredCampaignId = this.options.triggeredCampaignId;
        if (this.options.embedded) {
            if (this.options.usedFor === "trigger") {
                templateParams.trigger = true;
                templateParams.selectedTrigger = this.options.triggeredCampaignType;
            }
            if (this.options.id === this.model.get("campaignId")) {
                templateParams.selected = true;
            }
            templateParams.selectable = true;
        }

        this.$el.html(this.template(templateParams));

        let fullClass = serviceBalloonClass(serviceType, this.model.get(this.model.idAttribute));

        this.$el.addClass(fullClass);
        return this;
    },
    events: {
        'click .selectable': 'selectService'
    },
    selectService: function (event) {
        var method, extra;
        let serviceType = this.ServiceTypes[this.model.get("campaignTemplateType")];
        let usedFor = this.options.usedFor;

        switch (serviceType) {
            case "voucher":
                method = "selectVoucher";
                break;
            case "survey":
                method = "selectSurvey";
                break;
            case "optin":
                method = "selectOptin";
                extra = "optin";
                break;
            case "instantWin":
                if (this.model.get("instantWinPageConfig").get("type") === "USER_METRICS") {
                    method = "selectOptin";
                    extra = "sweepstakes";
                } else {
                    method = "selectOptin";
                    extra = "instantWin";
                }
                break;
            case "quiz":
                method = "selectOptin";
                extra = "quiz";
                break;
            case "payPalPayment": {
                let $target = $(event.target);
                if (usedFor === "trigger") {
                    if ($target.hasClass('paymentSelectable')) {
                        let selectedTrigger = $target.data('type');
                        method = "selectOptin";
                        extra = selectedTrigger;
                        // Add font weight to current selected one.
                        $(event.currentTarget).css("font-weight", 800);
                    } else {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        return;
                    }
                } else {
                    method = "selectOptin";
                    extra = "payment";
                }
                break;
            }
        }
        this.trigger("selected:service", {
            method,
            model: this.model.get("campaignId"),
            originalEvent: event,
            extra
        });
    }
});
// Returning instantiated views can be quite useful for having "state"
export default ResultView;
